import iconsUrl from '@assets/images/icons.svg';
import { IconName } from '@models';
import { BaseComponent } from '../base.component';
import defaultHtml from './icon.component.hbs';

export class IconComponent extends BaseComponent<never> {
    protected override bindEvent = undefined;
    protected override customTemplatePropertyName = 'icon';
    protected override defaultHtml = defaultHtml;

    private get size(): string {
        const size = this.getAttribute('size');

        if (!size) {
            return '1em';
        }

        if (isNaN(Number(size))) {
            return size;
        }

        return `${size}px`;
    }

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        const name = this.getAttribute('name') as IconName | null;

        if (!name) {
            return '';
        }

        const html = template({
            url: `${iconsUrl}#${name}`,
            height: this.size,
            width: this.size
        });

        return html;
    }
}
